import { render, staticRenderFns } from "./Quistioner.vue?vue&type=template&id=3622ae09&scoped=true&"
import script from "./Quistioner.vue?vue&type=script&lang=js&"
export * from "./Quistioner.vue?vue&type=script&lang=js&"
import style0 from "./Quistioner.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Quistioner.vue?vue&type=style&index=1&id=3622ae09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3622ae09",
  null
  
)

export default component.exports